<template>
  <div class="box">{{ row.endDate }}</div>
</template>
<script>
const moment = require('moment')
export default {
    props: {
        row: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    created() {
        console.log('证照年审', this.row)
    },
    methods: {
        formattime(val) {
            if (!val) {
                return
            } else {
                // let data = new Date()
                // let year = data.getFullYear()
                // let month = data.getMonth()+2
                // let date = data.getDate()
                // let nowdate = year+"-"+month+"-"+date
                // console.log("28",nowdate)
                return moment(val).format('YYYY-MM-DD')
            }
        },
        colorData(val) {
            const data = new Date()
            const year = data.getFullYear()
            const month = data.getMonth() + 2
            const date = data.getDate()
            const nowdate = year + '-' + month + '-' + date
            console.log('38', nowdate)
            if (val < nowdate) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.box {
  color: red;
}
</style>
